import { FunctionComponent, useState, useCallback } from 'react'
import { MdPlayArrow, MdRefresh } from 'react-icons/md'

import { string as yupString } from 'yup'

import iconPhone from 'shared/assets/icons/icon-telefone.png'
import Button from 'shared/components/Button'
import Form, { IProps as FormProps } from 'shared/components/Form'
import Input from 'shared/components/Input'
import Page from 'shared/components/Page'
import { colors } from 'shared/styles/colors'

import { ISmsProps } from './SmsComponent.types'
import { steps } from '../../'
import { ContainerForm, Container, ResendButton, ContainerText } from './styles'

const Sms: FunctionComponent<ISmsProps> = ({
  setSelectedStep,
  sendPin,
  verifyPin,
}) => {
  const [phone] = useState(() => {
    if (localStorage.getItem('@TMov:ChangeGestorPhone')) {
      return localStorage.getItem('@TMov:ChangeGestorPhone')
    }

    return ''
  })
  const [smsOk] = useState(true)
  const [loadingResend, setLoadingResend] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = useCallback(
    async (values: FormProps['values']) => {
      setLoading(true)
      setErrorMessage('')

      try {
        if (!values.code) {
          setErrorMessage('Informe o código')
          setLoading(false)

          return
        }

        const response = await verifyPin.execute({ code: values.code, phone })

        if (!response.valid) {
          setErrorMessage('Código inválido. Tente reenviar novamente.')
          setLoading(false)

          return
        }

        setSelectedStep(steps.Photo)
      } catch (e: unknown) {
        if (e instanceof Error) {
          setErrorMessage(e.message)
        } else {
          setErrorMessage('Erro ao tentar validar o pin')
        }
        setLoading(false)
      }
    },
    [setSelectedStep, verifyPin, phone],
  )

  const handleResendCode = useCallback(async () => {
    setErrorMessage('')
    setLoadingResend(true)

    try {
      await sendPin.execute({ phone })

      setLoadingResend(false)
    } catch (e: unknown) {
      if (e instanceof Error) {
        setErrorMessage(e.message)
      } else {
        setErrorMessage('Erro ao tentar enviar o pin')
      }
      setLoadingResend(false)
    }
  }, [phone, sendPin])

  return (
    <Page
      title="Certo, agora precisamos confirmar seu número.<br />Informe aqui o código que enviamos via SMS:"
      icon={iconPhone}
      goBackTo={() => {
        setSelectedStep(steps.Email)
      }}
    >
      <Container>
        <Form
          onSubmit={handleSubmit}
          initialValues={{ code: '' }}
          validationSchema={() => ({
            code: yupString().required(),
          })}
        >
          {formControl => (
            <ContainerForm>
              <ContainerText>
                <Input
                  placeholder="Digite apenas números"
                  name="code"
                  formControl={formControl}
                  errorMessage={errorMessage}
                />
              </ContainerText>

              <ResendButton
                transparent={true}
                color={colors.grayLight}
                disabled={loadingResend}
                loading={loadingResend}
                type="button"
                onClick={handleResendCode}
              >
                <MdRefresh /> REENVIAR CÓDIGO
              </ResendButton>

              <Button
                color={smsOk ? colors.green : colors.grayLight}
                disabled={!smsOk || loading}
                loading={loading}
                type="submit"
                onClick={formControl.handleSubmit}
              >
                <MdPlayArrow /> Validar código
              </Button>
            </ContainerForm>
          )}
        </Form>
      </Container>
    </Page>
  )
}

export default Sms
